import {Component, EventEmitter, Input, Output} from '@angular/core';

import {DesignService} from '@services/left-menu/design/design.service';

import {MenuItemType} from '@models/sidebar/menu-item-type';
import {PageItem} from '@models/sidebar/page-item';
import {PageTypeOption} from '@models/sidebar/response/page-type-option';

@Component({
    selector: 'scitis-second-level-page-item',
    templateUrl: './second-level-page-item.component.html',
    styleUrls: ['./second-level-page-item.component.scss'],
    standalone: false
})
export class SecondLevelPageItemComponent {

  @Input()
  nodeUserMenuItem: PageItem = new PageItem();

  @Input()
  pageTypeOptions: PageTypeOption[] = [];

  @Input()
  baseMenuItems: PageItem[] = [];

  @Input()
  userMenuItems: PageItem[] = [];

  @Input()
  allPagesInsideNode: PageItem[] = [];

  @Input()
  isAdminOrHigher: boolean = false;

  @Input()
  isHigherThanAdmin: boolean = false;

  @Output()
  sharePageItemInsideNode: EventEmitter<PageItem> = new EventEmitter<PageItem>();

  @Output()
  deletePageItemInsideNode: EventEmitter<PageItem> = new EventEmitter<PageItem>();

  @Output()
  savePageItemInsideNode: EventEmitter<PageItem> = new EventEmitter<PageItem>();

  @Output()
  disableSaveButton: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  pageFormIsActive: EventEmitter<PageItem | null> = new EventEmitter<PageItem | null>();

  editPageName: boolean = false;

  constructor(private designService: DesignService) {
  }

  get iconClass(): string {
    return this.designService.getIcon(MenuItemType.USER_DEFINED_PAGE).toString();
  }

  get formIsActive(): boolean {
    return <boolean>this.nodeUserMenuItem?.formIsActive;
  }

  editPage(): void {
    this.editPageName = true;
    this.disableSaveButton.emit(true);
    this.nodeUserMenuItem.formIsActive = true;
    this.pageFormIsActive.emit(this.nodeUserMenuItem);
  }

  sharePage(nodeUserMenuItem: PageItem): void {
    this.sharePageItemInsideNode.emit(nodeUserMenuItem);
    this.disableSaveButton.emit(false);
  }

  deletePage(nodeUserMenuItem: PageItem): void {
    this.deletePageItemInsideNode.emit(nodeUserMenuItem);
    this.disableSaveButton.emit(false);
  }

  onSavePage(nodeUserMenuItem: PageItem): void {
    this.savePageItemInsideNode.emit(nodeUserMenuItem);
    this.editPageName = false;
    this.disableSaveButton.emit(false);
    this.pageFormIsActive.emit(null);
  }

  onCancelSavePage(): void {
    this.editPageName = false;
    this.disableSaveButton.emit(false);
    this.pageFormIsActive.emit(null);
  }

}
